import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getParticipantsShareScreen } from '../../../base/tracks/functions.any';
import { IconScreenshare } from '../../../base/icons/svg';
import { useTranslation } from 'react-i18next';
import { Button, Popover, Tooltip } from '@mui/material';
import { startScreenShareFlow } from '../../../screen-share/actions.web';
import { pinParticipant } from '../../../base/participants/actions';
import ShareScreenController from './ShareScreenController';
import { addStageParticipant } from '../../../filmstrip/actions.web';
import { getLocalDisplayName } from '../../../base/participants';
const SharescreenList = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const _listParticipantsShareScreen = useSelector((state) => getParticipantsShareScreen(state));
    const localDisplayName = useSelector(getLocalDisplayName);
    const [anchorEl, setAnchorEl] = useState(null);
    const [openByName, setOpenByName] = useState(true);
    /**
     * Hiển thị danh sách chia sẻ màn hình
     * @param event
     * @param by
     */
    const handleOpenPopover = (event, by = "name") => {
        if (_listParticipantsShareScreen.length > 1) {
            setAnchorEl(event.currentTarget);
            setOpenByName(by === "name");
        }
    };
    /**
     * Stop chia sẻ màn hình
     */
    const handleStopShare = () => {
        dispatch(startScreenShareFlow(false));
        handleClosePopover();
    };
    /**
     * Ghim chia sẻ màn hình
     * @param participantId
     */
    const handlePinSharescreen = (participantId) => {
        dispatch(pinParticipant(`${participantId}-v0`));
        dispatch(addStageParticipant(`${participantId}-v0`, true));
    };
    /**
     * Ẩn danh sách chia sẻ màn hình
     * @returns
     */
    const handleClosePopover = () => setAnchorEl(null);
    return (React.createElement("div", { className: `share-screen-box ${_listParticipantsShareScreen.length > 1 || (_listParticipantsShareScreen.length > 0 && _listParticipantsShareScreen[0].local) ? '' : 'share-screen-box-zero'}` }, Boolean(_listParticipantsShareScreen.length) && React.createElement("div", { className: 'info-share-screen-user' },
        React.createElement("span", { className: `info-user-share ${_listParticipantsShareScreen.length === 1 ? 'cursor-default' : ''}`, onClick: (event) => handleOpenPopover(event, "name") },
            React.createElement(IconScreenshare, null),
            React.createElement("span", null, `${_listParticipantsShareScreen[0].local ? localDisplayName : _listParticipantsShareScreen[0]?.name} ${_listParticipantsShareScreen[0].local ? `(${t("conferenceInfo.you")})` : ''} ${t("conferenceInfo.sharing")}`),
            Boolean(_listParticipantsShareScreen.length > 1) && _listParticipantsShareScreen[0].local && React.createElement("span", { className: 'number-participant-share' }, _listParticipantsShareScreen.length),
            React.createElement(ShareScreenController, null)),
        Boolean(_listParticipantsShareScreen.length > 1) && !_listParticipantsShareScreen[0].local && React.createElement(Tooltip, { title: t("conferenceInfo.listScreenShare") },
            React.createElement("span", { className: 'number-participant-share cursor-pointer', onClick: (event) => handleOpenPopover(event, "number") }, _listParticipantsShareScreen.length)),
        _listParticipantsShareScreen[0].local && React.createElement("div", { className: 'action-user-share' },
            React.createElement(Button, { size: 'small', variant: 'text', onClick: handleStopShare }, t("conferenceInfo.stopShare"))),
        React.createElement(Popover, { id: 'popover-list-participant', className: `popover-participants-share-screen ${openByName ? 'open-by-name' : 'open-by-number'}`, open: Boolean(anchorEl), anchorEl: anchorEl, onClose: handleClosePopover, anchorOrigin: {
                vertical: 'bottom',
                horizontal: openByName ? 'left' : 'right',
            }, transformOrigin: {
                vertical: 'top',
                horizontal: openByName ? 'left' : 'right',
            } }, _listParticipantsShareScreen.map(participant => (React.createElement("div", { className: 'info-share-screen-user', key: participant.participantId },
            React.createElement(Tooltip, { title: t("conferenceInfo.goScreenShare", { name: participant?.name }) },
                React.createElement("span", { className: 'info-user-share', onClick: () => handlePinSharescreen(participant?.participantId) },
                    React.createElement(IconScreenshare, null),
                    React.createElement("span", null, `${participant?.name} ${participant?.local ? `(${t("conferenceInfo.you")})` : ''} ${t("conferenceInfo.sharing")}`))),
            participant?.local && React.createElement("div", { className: 'action-user-share' }, React.createElement(Button, { size: 'small', variant: 'text', onClick: handleStopShare }, t("conferenceInfo.stopShare"))))))))));
};
export default SharescreenList;
